import { toast } from "sonner";
import { ApiResponse } from "../types/Query";
import customFetch from "../util/config/axiosConfig";
import { SalaryStructureResponse } from "../types/payrollType";

const payrollManagement = {
  // PUT Statutory Components
  updateStatutoryComponent: async (
    staffId: number,
    payload: {
      professionalTaxEnabled: boolean;
      employeePfEnabled: boolean;
      pfNumber?: string;
    },
  ): Promise<ApiResponse<string> | undefined> => {
    try {
      const response = await customFetch.put(
        `/api/v1/salary/statutory-component/${staffId}`,
        payload,
      );

      toast.success(response.data?.data || "Updated successfully");
      return response.data;
    } catch (error: any) {
      console.error("Error updating statutory component:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to update statutory component",
      );
    }
  },

  // PUT Salary Structure
  updateSalaryStructure: async (
    staffId: number,
    payload: {
      basicSalary: number;
      pfAmount: number;
      professionalTaxAmount: number;
      otherSalaryComponents: Record<string, string>;
      totalEarning: number;
    },
  ): Promise<ApiResponse<string> | undefined> => {
    try {
      const response = await customFetch.put(
        `/api/v1/salary/salary-structure/${staffId}`,
        payload,
      );

      toast.success(response.data?.data || "Salary updated successfully");
      return response.data;
    } catch (error: any) {
      console.error("Error updating salary structure:", error);
      toast.error(
        error?.response?.data?.message || "Failed to update salary structure",
      );
    }
  },

  getSalaryStructure: async (
    staffId: number,
  ): Promise<ApiResponse<SalaryStructureResponse> | undefined> => {
    try {
      const response = await customFetch.get(`/api/v1/salary/${staffId}`);

      return response.data;
    } catch (error) {
      console.error("Error fetching salary:", error);
      toast.error("Failed to fetch salary");
    }
  },
};
export default payrollManagement;
